import { render, staticRenderFns } from "./CohortColorPickerDialog.vue?vue&type=template&id=71acf02e&scoped=true"
import script from "./CohortColorPickerDialog.vue?vue&type=script&lang=js"
export * from "./CohortColorPickerDialog.vue?vue&type=script&lang=js"
import style0 from "./CohortColorPickerDialog.vue?vue&type=style&index=0&id=71acf02e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71acf02e",
  null
  
)

export default component.exports